import React, { Component } from 'react';
import {
    Form, Input, Button, Select, Modal,
} from 'antd';

import 'antd/dist/antd.css';

const Option = Select.Option;

function handleChange(value) {
  console.log(`selected ${value}`);
}

function handleBlur() {
  console.log('blur');
}

function handleFocus() {
  console.log('focus');
}

class MachineContactsAddView extends Component {
    constructor(props) {
        super(props);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleSubmit(e) {
        e.preventDefault();
        // console.log(e);
        this.props.form.validateFields((err, values) => {
            if (!err) {
                this.props.handleSubmit(values);
                this.props.form.resetFields();
            }
        });
    }

    render() {
        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 8 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 16 },
            },
        };
        const tailFormItemLayout = {
            wrapperCol: {
                xs: {
                    span: 24,
                    offset: 0,
                },
                sm: {
                    span: 16,
                    offset: 8,
                },
            },
        };
        const { getFieldDecorator } = this.props.form;
        const { manager } = this.props;
        return (
            <div>
                <Modal
                    title="Manejo de Contacto"
                    visible={this.props.openForm}
                    onOk={this.handleOk}
                    onCancel={this.props.onCancel}
                    footer={null}
                >
                    <Form onSubmit={this.handleSubmit}>
                        <Form.Item
                            {...formItemLayout}
                            label="Nombre"
                        >
                            {getFieldDecorator('name', {
                                initialValue: (manager != null) ? manager.name : '',
                                rules: [{ required: true, message: 'Ingrese Su Nombre' }],
                            })(
                                <Input type="text" />,
                            )}
                        </Form.Item>
                        <Form.Item
                            {...formItemLayout}
                            label="Apellido"
                        >
                            {getFieldDecorator('lastname', {
                                initialValue: (manager != null) ? manager.lastname : '',
                                rules: [{ required: true, message: 'Ingrese Su Apellido' }],
                            })(
                                <Input type="text" />,
                            )}
                        </Form.Item>
                        <Form.Item
                            {...formItemLayout}
                            label="Correo Electrónico"
                        >
                            {getFieldDecorator('email', {
                                initialValue: (manager != null) ? manager.email : '',
                            })(
                                <Input type="email" />,
                            )}
                        </Form.Item>
                        <Form.Item
                            {...formItemLayout}
                            label="Teléfono 1"
                        >
                            {getFieldDecorator('phone1', {
                                initialValue: (manager != null) ? manager.phone1 : '',
                                rules: [{ required: true, message: 'Ingrese Su Teléfono' }],
                            })(
                                <Input type="text" />,
                            )}
                        </Form.Item>
                        <Form.Item
                            {...formItemLayout}
                            label="Teléfono 2"
                        >
                            {getFieldDecorator('phone2', {
                                initialValue: (manager != null) ? manager.phone2 : '',
                            })(
                                <Input type="text" />,
                            )}
                        </Form.Item>
                        <Form.Item
                            {...formItemLayout}
                            label="Empresa"
                        >
                            {getFieldDecorator('company', {
                                initialValue: (manager != null) ? manager.company : '',
                                rules: [{ required: true, message: 'Ingrese Su Empresa' }],
                            })(
                                <Input type="text" />,
                            )}
                        </Form.Item>
                        <Form.Item
                            {...formItemLayout}
                            label="Máquinas"
                        >
                            {getFieldDecorator('machine', {
                                initialValue: (manager != null) ? manager.machine : '',
                                rules: [{ required: true, message: 'Ingrese Máquina' }],
                            })(
                                <Input.TextArea rows={4} />,
                            )}
                        </Form.Item>
                        <Form.Item
                            {...formItemLayout}
                            label="Descripción"
                        >
                            {getFieldDecorator('description', {
                                initialValue: (manager != null) ? manager.description : '',
                                rules: [{ required: true, message: 'Ingrese Su descripción' }],
                            })(
                                <Input.TextArea rows={4} />,
                            )}
                        </Form.Item>
                        <Form.Item {...tailFormItemLayout}>
                            <Button type="primary" htmlType="submit" onClick={this.handleOk} >
                                Guardar
                            </Button>
                        </Form.Item>
                    </Form>
                </Modal>
            </div>
        );
    }
}

export default Form.create()(MachineContactsAddView);



// WEBPACK FOOTER //
// ./src/components/views/MachineContactsAddView.js